<app-modal-wrapper [title]="'Create new artist' | translate" (closeAction)="close()">
  <form
    id="formArtist"
    modalBody
    [formGroup]="artistUploadData.formGroup"
    vgFocusFirstInvalid
    [form]="artistUploadData.formGroup"
    (ngSubmit)="onSubmit()"
    class="modal-body"
  >
    <div class="form-group">
      <label for="artistName">{{ 'feature.artist.artist_name' | translate }}</label>
      <input
        type="text"
        class="form-control"
        id="artistName"
        [placeholder]="('Enter' | translate) + ' ' + ('Artist Name' | translate)"
        formControlName="name"
      />
      <vg-error-section [label]="'Artist Name' | translate" [group]="artistUploadData.formGroup" controlName="name"></vg-error-section>
    </div>
    <div class="form-group">
      <label for="birthDate">{{ 'BirthDate' | translate }}</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="dd/MM/yyyy"
          id="birthDate"
          name="dp"
          ngbDatepicker
          #d="ngbDatepicker"
          formControlName="birthDate"
          [minDate]="minDate"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
            <i class="bi bi-calendar3"></i>
          </button>
        </div>
      </div>
      <vg-error-section [label]="'BirthDate' | translate" [group]="artistUploadData.formGroup" controlName="birthDate"></vg-error-section>
    </div>
    <div class="form-group">
      <label for="avatar">{{ 'Avatar' | translate }}</label>
      <vg-file-input
        id="avatar"
        formControlName="avatarUrl"
        [formData]="artistUploadData.formData"
        [remoteFileType]="'image'"
        [formDataFilePart]="'avatar'"
      ></vg-file-input>
    </div>
    <div class="form-group my-2">
      <label for="biography">{{ 'feature.artist.biography' | translate }}</label>
      <textarea class="form-control" id="biography" formControlName="biography"></textarea>
    </div>
    <vg-upload-progress [httpObs]="artistUploadData.observable" (successEvent)="onUpdateSuccess($event)"></vg-upload-progress>
  </form>
  <ng-container modalFooter>
    <button type="submit" form="formArtist" ngbAutofocus class="btn btn-primary mr-2" [disabled]="loading">
      <span>{{ 'common.button.save' | translate }}</span>
    </button>
    <button type="button" class="btn btn-secondary" [disabled]="loading" (click)="close()">
      <span>{{ 'common.button.cancel' | translate }}</span>
    </button>
  </ng-container>
</app-modal-wrapper>
